import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * ChatMessage Schema
 * Team chat for the mobile app — one message in a DivisionTeam's room.
 * Scoped to DivisionTeam (the entity games, rosters and "my teams" already
 * resolve to), with a denormalized organization ref for indexing/scoping.
 * `kind: 'announcement'` is reserved for senders in the division/league/
 * tournament admins union (same union as ADR 0016's admin emails); absent
 * `kind` means a plain message.
 */
export const ChatMessageSchema = z.object({
  _id: objectId,
  divisionTeam: objectId,
  organization: objectId.optional(),
  sender: objectId,
  text: z.string().min(1).max(2000),
  kind: z.enum(['message', 'announcement']).optional(),
  ...timestampFields,
});

export type ChatMessage = z.infer<typeof ChatMessageSchema>;

export const chatMessageMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  divisionTeam: { ref: 'DivisionTeam', label: 'Team' },
  organization: { ref: 'Organization', label: 'Organization' },
  sender: { ref: 'User', label: 'Sender' },
  text: { label: 'Message' },
  kind: { label: 'Kind' },
  created: { hidden: true },
  updated: { hidden: true },
};
